import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DataObject } from 'src/app/core/models/core.models';

@Component({
  selector: 'app-dataobject-list-simple',
  templateUrl: './dataobject-list-simple.component.html',
  styleUrl: './dataobject-list-simple.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DataobjectListSimpleComponent {
  /**
   * Objects to render
   */
  @Input() objects: DataObject[] = [];

  /**
   * Max height of the scrollable area (CSS length).
   * Example values: '280px', '40vh', '100%'.
   */
  @Input() maxHeight: string = '14.285rem';

  /** Compact item height in pixels */
  readonly itemHeight = 40;

  trackById = (_: number, item: DataObject) => item.id;

  ngOnInit(): void {
    if (!this.objects) {
      this.objects = [];
    }
  }

  initialOf(obj: DataObject): string {
    const t = (obj.title || obj.name || '').trim();
    return t ? t.charAt(0).toUpperCase() : '?';
  }
}
